import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Text from 'atoms/Text';

const LogoutIcon = () => (
  <svg
    className="w-4 h-4 shrink-0"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <path d="M21 12H9" />
  </svg>
);

const ProfileMenu = ({ onLogout, onClose }) => {
  const menuRef = useRef(null);

  // Escape closes, and focus moves to the item on open so the menu is operable
  // without a mouse — the markup this replaced was a div with an onClick,
  // reachable by neither keyboard nor screen reader.
  useEffect(() => {
    const firstItem = menuRef.current?.querySelector('[role="menuitem"]');
    if (firstItem) firstItem.focus();

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      role="menu"
      aria-label="Account menu"
      className="absolute z-[62] right-0 top-full mt-1 w-[140px] xl:w-[160px] rounded border border-secondary-200 bg-white py-1 shadow-card"
      onClick={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        role="menuitem"
        className="flex w-full items-center gap-2.5 px-3 py-2 text-left cursor-pointer transition-colors duration-150 hover:bg-primary-400 focus-visible:outline-none focus-visible:bg-primary-400 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-500"
        onClick={onLogout}
      >
        <span className="text-error-300">
          <LogoutIcon />
        </span>
        <Text variant="bodySmall" textColor="text-error-300" fontFamily="">
          Logout
        </Text>
      </button>
    </div>
  );
};

ProfileMenu.propTypes = {
  onLogout: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ProfileMenu;
